import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanDeactivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { PageLeaveService } from '../services/page-leave.service';
import { AudiogramComparisonPageLeaveDataService } from '../services/audiogram-comparison-page-leave-data.service';

@Injectable({
  providedIn: 'root'
})
export class AudiogramCompareGuard implements CanDeactivate<unknown> {
  constructor(
    private pageLeaveService : PageLeaveService,
    private audiogramComparisonPageLeaveDataService: AudiogramComparisonPageLeaveDataService
  ) {}
  
  canDeactivate(
    component: unknown,
    currentRoute: ActivatedRouteSnapshot,
    currentState: RouterStateSnapshot,
    nextState?: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
      const value = this.audiogramComparisonPageLeaveDataService.getValue();
      if (value.value == 'modified' && value.page == 'audiogram-compare') {
        return this.pageLeaveService.confirm().then(confirmed => {
          if (confirmed) {
            try {
              let response = this.audiogramComparisonPageLeaveDataService.saveParams().toPromise();
              return true;
            } catch (e) {console.log(3)
              return false;
            }
          } else 
          {
            return true;
          }          
        });
      } else {
        return true;
      }
      
  }
}
